import {
  AccordionRadioGroups,
  Consent,
  DatePattern,
  DatePicker,
  FileUpload,
  Hidden,
  Input,
  LabelOnly,
  NestedSelect,
  NumberInput,
  Phone,
  RadioButtonGroup,
  SearchInput,
  Select,
  Textarea,
  Toggle,
  Typeahead,
  Wysiwyg,
} from '~/core/shared/components';
import {
  FormFieldComponent,
  WorkflowStepFormFieldType,
} from '~/core/shared/types';

export const getComponentFromWorkflowStepFormFieldType = (
  type: WorkflowStepFormFieldType,
): FormFieldComponent => {
  switch (type) {
    case 'accordion-radio-groups':
      return AccordionRadioGroups;

    case 'consent':
      return Consent;

    case 'date-picker':
      return DatePicker;

    case 'date-pattern':
      return DatePattern;

    case 'file-upload':
      return FileUpload;

    case 'input':
      return Input;

    case 'label-only':
      return LabelOnly;

    case 'hidden':
      return Hidden;

    case 'phone':
      return Phone;

    case 'nested-select':
      return NestedSelect;

    case 'number-input':
      return NumberInput;

    case 'radio-button-group':
      return RadioButtonGroup;

    case 'search-input':
      return SearchInput;

    case 'select':
      return Select;

    case 'textarea':
      return Textarea;

    case 'toggle':
      return Toggle;

    case 'typeahead':
      return Typeahead;

    case 'wysiwyg':
      return Wysiwyg;

    default:
      throw new Error('Unknown form field type');
  }
};
